export * from './display-percentage'



// WEBPACK FOOTER //
// ./src/app/shared/components/display-percentage/index.ts